import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Radios from '../../Components/ComponentRadios';
import Checkbox from '../../Components/ComponentCheckbox';
import SignupFormAction from './components/SignupFormAction';
import T from './Locale';
/**
 * Get all consents to add from an index.
 *
 * @param {object} consent
 * @param {int} index
 *
 * @returns {[]}
 */
const getConsentsToAdd = (consent, index) => {
    return consent.options[index].consentType.filter((consent) => consent !== 'none');
};
/**
 * Iterate all options and combine the consent types.
 *
 * @param {object} consent
 *
 * @returns {[]}
 */
const getAllConsentTypes = (consent) => {
    let consents = [];
    consent.options.forEach((option) => {
        consents = consents.concat(option.consentType);
    });
    return consents.filter((consent) => consent !== 'none');
};
const Consents = ({ consent, onChange, error, className = '' }) => {
    const [selectedRadios, setSelectedRadios] = useState({});
    const consentId = consent.text.replace(/[^a-z]/g, '');
    const selectRadio = (consent, index) => {
        setSelectedRadios(Object.assign(Object.assign({}, selectedRadios), { [consentId]: index }));
        onChange(consentId, consent.options[index].text, getConsentsToAdd(consent, index), getAllConsentTypes(consent));
    };
    const selectCheckbox = (consent, isChecked) => {
        if (isChecked) {
            onChange(consentId, isChecked, getConsentsToAdd(consent, 0), getAllConsentTypes(consent));
        }
        else {
            onChange(consentId, isChecked, [], getAllConsentTypes(consent));
        }
    };
    switch (consent.inputType) {
        case 'checkbox':
            return (_jsx("div", Object.assign({ className: 'flex flex-row mb-4' }, { children: _jsx(Checkbox, { id: consent.id, label: consent.text, classes: `leading-relaxed cursor-pointer ${className}`, onChange: (checked) => selectCheckbox(consent, checked), error: error ? consent.error || T('partner.signup.errors.consent') : '' }) })));
        case 'radio':
            return (_jsx(SignupFormAction, Object.assign({ title: consent.text, error: error ? consent.error || T('partner.signup.errors.consent') : false }, { children: _jsx(Radios, { name: consentId, options: (() => {
                        const options = {};
                        consent.options.map((option, index) => (options[option.text] = index));
                        return options;
                    })(), selectedValue: selectedRadios[consentId], onSelect: (selectedIndex) => selectRadio(consent, selectedIndex), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) })));
    }
};
Consents.protoTypes = {
    consent: PropTypes.shape({
        inputType: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        error: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string,
            consentType: PropTypes.arrayOf(PropTypes.string)
        }))
    }),
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    className: PropTypes.string
};
export default Consents;
